

















import Vue from 'vue'
import Preview from '@/components/preview.vue'
import Sidebar from '@/components/Sidebar.vue'
import { navigators } from '../data'

export default Vue.extend({
  components: {
    Preview,
    Sidebar
  },
  data () {
    return {
      title: 'Setting Page',
      navigators
    }
  }
})
